let isDev: boolean = document.domain === "localhost" && location.port === "8080";
let isStage: boolean =
    document.domain === "central.test.axxess.tech" || document.domain === "central.stage.axxess.tech";
const localGlobal = window as any;
const _hospiceUrl: string =
    localGlobal._hospiceUrl?.startsWith("#") || localGlobal._hospiceUrl == null
        ? "http://hospice.dev.axxess.tech"
        : localGlobal._hospiceUrl;
const _palliativeUrl: string =
    localGlobal._palliativeUrl?.startsWith("#") || localGlobal._palliativeUrl == null
        ? "http://palliativecare.dev.axxess.tech"
        : localGlobal._palliativeUrl;
const _nalaUrl: string =
    localGlobal._nalaUrl?.startsWith("#") || localGlobal._nalaUrl == null
        ? "http://nala.rcm.lan"
        : localGlobal._nalaUrl;
const _mushuUrl: string =
    localGlobal._mushuUrl?.startsWith("#") || localGlobal._mushuUrl == null
        ? "http://mushu.rcm.lan"
        : localGlobal._mushuUrl;
const _messagingServerUrl: string =
    localGlobal._messagingServiceServerURL?.startsWith("#") || localGlobal._messagingServiceServerURL == null
        ? "https://messaging-api.test.axxess.tech"
        : localGlobal._messagingServiceServerURL;
const _vccServerUrl: string =
    localGlobal._vccServerURL?.startsWith("#") || localGlobal._vccServerURL == null
        ? "https://vcc1.test.axxess.tech"
        : localGlobal._vccServerURL;
const _assetServerStorageUrl: string =
    localGlobal._assetServerStorageURL?.startsWith("#") || localGlobal._assetServerStorageURL == null
        ? "https://com-asset-storage-api.test.axxess.tech"
        : localGlobal._assetServerStorageURL;
const _vcpServerUrl: string =
    localGlobal._vcpServerURL?.startsWith("#") || localGlobal._vcpServerURL == null
        ? "https://vcp1.test.axxess.tech"
        : localGlobal._vcpServerURL;
const _authorityUrl: string =
    localGlobal._authorityUrl?.startsWith("#") || localGlobal._authorityUrl == null
        ? "https://identity.test.axxess.tech/"
        : localGlobal._authorityUrl;

const _hospiceReceptionistUrl: string =
    localGlobal._hospiceReceptionistURL?.startsWith("#") || localGlobal._hospiceReceptionistURL == null
        ? "http://hospice-receptionist.test.axxess.tech"
        : localGlobal._hospiceReceptionistURL;

const _googleApiKey: string = isDev ? "AIzaSyA9ZkE3uNo-75pnS-8YTKvKv7oGWB30GCo" : localGlobal._googleApiKey;

export default {
    googleMapsApiKey: _googleApiKey,
    hospiceUrl: _hospiceUrl, // isDev || isStage ? "http://hospice.test.axxess.tech" : "https://hospice.axxessweb.com",
    mushuUrl: isDev || isStage ? _mushuUrl : "https://revenue.axxessweb.com",
    biApiUrl: "https://biapi.axxessweb.com",
    biUrl: "https://bi.axxessweb.com",
    certificationUrl: "https://certification.axxessweb.com",
    supportUrl: "https://www.axxess.com/support/",
    palliativeUrl: _palliativeUrl, // Info Purpose only: isDev || isStage ? "http://palliativecare.test.axxess.tech" : "https://palliativecare.axxessweb.com",
    nalaUrl: _nalaUrl,
    hospiceMarketingUrl: "http://www.axxess.com/hospice",
    covidMarketingUrl: "https://www.axxess.com/help/coronavirus-covid-19-resources/",
    simiTreeUrl: "https://gae2784720a2099-simitreeprod.adb.us-ashburn-1.oraclecloudapps.com/ords/r/rg",
    weatherCacheKey: "axxess-user-weather",
    appCacheKey: "router-token",
    locationCacheKey: "axxess-user-location",
    defaultRoute: "help",
    isDev,
    isStage,
    hospiceMarketingLastDate: "12/05/2019",
    covidMarketingLastDate: "05/15/2020",
    linesOfServiceSurveyLastDate: "07/02/2020",
    locationSaveKey: "router-oidc-redirect",
    identityTimeOut: 3000,
    pageSize: 10,
    stateListCacheKey: "AxxessCentralStateListCacheKey",
    countryListCacheKey: "AxxessCentralCountryListCacheKey",
    countryPhoneCodeListCacheKey: "AxxessCentralCountryPhoneCodeListCacheKey",
    enumCacheKey: "AxxessCentralEnumCacheKey",
    hospiceAssetServerURL: "https://com-asset-storage-api.test.axxess.tech",
    palliativeAssetServerURL: "https://com-asset-storage-api.test.axxess.tech",
    messagingServiceServerURL: _messagingServerUrl,
    AudioVideoServiceServerURL: _vccServerUrl,
    assetServerStorageURL: _assetServerStorageUrl,
    vcpServerURL: _vcpServerUrl,
    axxessCentralUrl: "https://central.axxessweb.com",
    organizationId: "organization-id",
    organizationName: "organization-name",
    hospiceReceptionistUrl: _hospiceReceptionistUrl,
    authorityUrl: _authorityUrl
};
